"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var react_socks_1 = __importDefault(require("react-socks"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var DisclaimersWrapper_1 = __importDefault(require("./styledComponents/DisclaimersWrapper"));
var ChartBaseFunctions_1 = require("./ChartBaseFunctions");
var ChartBase_meta_1 = require("./ChartBase.meta");
var Recharts = __importStar(require("recharts"));
var Translate_1 = require("../../base/Translate/Translate");
var Disclaimers_1 = __importDefault(require("../../overview/Disclaimers/Disclaimers"));
var DefaultLegendContent_1 = __importDefault(require("./components/DefaultLegendContent"));
var ChartSummary_1 = __importDefault(require("./styledComponents/ChartSummary"));
var guid_1 = require("@kurtosys/ksys-app-template/dist/utils/guid");
var Accessibility_1 = require("../../base/Accessibility/Accessibility");
var formatter = ksys_app_template_1.utils.formatter.formatter;
var ChartBase = /** @class */ (function (_super) {
    __extends(ChartBase, _super);
    function ChartBase(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = ChartBase_meta_1.CHART_BASE_CATEGORY_KEY;
        _this.componentKey = ChartBase_meta_1.CHART_BASE_COMPONENT_KEY;
        _this.renderChart = function (props, translationContext, accessibilityContext) {
            var _a;
            if (!props) {
                return null;
            }
            var responsiveContainerProps = _this.getResponsiveContainerProps(props);
            var _b = props.composedChartProps, composedChartProps = _b === void 0 ? {} : _b, _c = props.elements, elements = _c === void 0 ? [] : _c, rebaseOptions = props.rebaseOptions, _d = props.chartBaseComponent, chartBaseComponent = _d === void 0 ? 'ComposedChart' : _d, appKey = props.appKey, queryStore = props.queryStore;
            var disclaimersProps = props.disclaimersProps;
            ChartBaseFunctions_1.applyTranslationsToComposedChartProps(composedChartProps, translationContext);
            ChartBaseFunctions_1.applyRebaseToComposedChartProps(composedChartProps, rebaseOptions);
            var cleanConfigurations = props.cleanConfigurations;
            var dataLength;
            var data = composedChartProps && composedChartProps.data;
            elements && elements.push.apply(elements, ChartBaseFunctions_1.getDynamicReferenceLines(elements, composedChartProps, cleanConfigurations));
            var chartProps = {};
            var combinedTicks = [];
            var combinedTickCount = 0;
            var syncTicks;
            var chartSummary = undefined;
            if (cleanConfigurations) {
                if (cleanConfigurations.length > 0) {
                    chartProps = cleanConfigurations[cleanConfigurations.length - 1];
                    // Set up the data with the rebased composed chart props data
                    data = data || chartProps.data;
                    dataLength = data && data.length;
                    chartSummary = cleanConfigurations[1] && cleanConfigurations[1].summary;
                }
                syncTicks = ChartBaseFunctions_1.getChartSyncTicks(chartProps, elements, composedChartProps);
                // Used to allow the x and y axis to have the same ticks
                if (syncTicks) {
                    combinedTicks = syncTicks.ticks;
                    combinedTickCount = syncTicks.tickCount;
                }
            }
            var hasSuperscriptDisclaimer = false;
            // appKey is required so that we don't get all disclaimers returning when they are not setup
            if (appKey) {
                hasSuperscriptDisclaimer = ChartBaseFunctions_1.applyGlobalDisclaimers(elements, data, queryStore, appKey);
                ksys_app_template_1.utils.globalDisclaimers.initializeGlobalDisclaimers();
                var globalDisclaimerStore = ksys_app_template_1.utils.globalDisclaimers.getGlobalDisclaimerStore();
                if (globalDisclaimerStore) {
                    var disclaimers = [];
                    // gets all disclaimers to show at the bottom of the chart
                    disclaimers.push.apply(disclaimers, globalDisclaimerStore.get(ksys_app_template_1.models.disclaimers.GlobalDisclaimerLevel.app, appKey));
                    if (disclaimers && disclaimers.length > 0) {
                        disclaimersProps = disclaimersProps || {};
                        disclaimersProps.disclaimers = disclaimersProps.disclaimers || [];
                        (_a = disclaimersProps.disclaimers).push.apply(_a, disclaimers);
                    }
                }
            }
            var ChartBaseComponent = Recharts[chartBaseComponent];
            var chartAccessibilitySummary = accessibilityContext.accessibilityText('charting.summary', '');
            var summaryId = chartSummary ? "chart-summary-" + guid_1.generateGuid() : '';
            return (react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(react_1.Fragment, null,
                    chartSummary && react_1.default.createElement(ChartSummary_1.default, { id: summaryId, title: chartSummary, level: 2 }),
                    react_1.default.createElement("div", __assign({}, _this.getChartContainerProps(summaryId, chartSummary, chartAccessibilitySummary)),
                        react_1.default.createElement(Recharts.ResponsiveContainer, __assign({}, responsiveContainerProps, { minHeight: "600px" }),
                            react_1.default.createElement(ChartBaseComponent, __assign({}, composedChartProps), elements.map(function (element, elementIndex) {
                                // reset element.props.length to data length
                                ChartBaseFunctions_1.applyDataLength(element, dataLength);
                                ChartBaseFunctions_1.applyTranslations(element, translationContext);
                                // if not using equal axis ticks, fall back to original logic
                                if (syncTicks &&
                                    (element.type === 'XAxis' || element.type === 'YAxis') &&
                                    element.props) {
                                    element.props.ticks = combinedTicks;
                                    element.props.tickCount = combinedTickCount;
                                }
                                else {
                                    ChartBaseFunctions_1.applyTickPivotPoint(element, elements, composedChartProps);
                                }
                                ChartBaseFunctions_1.applyFormatters(element, translationContext);
                                ChartBaseFunctions_1.applyCustomTickLabel(element, translationContext);
                                ChartBaseFunctions_1.applySeriesLabels(element, translationContext);
                                ChartBaseFunctions_1.applyCustomTickValues(element, props);
                                ChartBaseFunctions_1.applyAnimationLogic(element, props);
                                ChartBaseFunctions_1.validateLegendElement(element, data);
                                if (element.type === 'Legend' && element.props) {
                                    element.props.content = react_1.default.createElement(DefaultLegendContent_1.default, __assign({}, element.props));
                                }
                                var type = element.type, _a = element.props, elementProps = _a === void 0 ? {} : _a;
                                // Recharts Text element does not work so we need to implement a custom one
                                if (type === 'Text') {
                                    var _b = elementProps, label = _b.label, scaleToFit = _b.scaleToFit, verticalAnchor = _b.verticalAnchor, lineHeight = _b.lineHeight, textProps = __rest(_b, ["label", "scaleToFit", "verticalAnchor", "lineHeight"]);
                                    return (react_1.default.createElement("text", __assign({ key: elementIndex }, textProps), elementProps.label));
                                }
                                var RechartsElement = Recharts[type];
                                return (react_1.default.createElement(RechartsElement, __assign({ key: elementIndex }, elementProps),
                                    _this.getLabelList(elementProps),
                                    element.type === 'ReferenceLine' && _this.getLabel(elementProps),
                                    element.type === 'Bar' &&
                                        _this.getCells(elementProps, composedChartProps && composedChartProps.data)));
                            }))))),
                disclaimersProps && (react_1.default.createElement(DisclaimersWrapper_1.default, null,
                    react_1.default.createElement(Disclaimers_1.default, __assign({}, disclaimersProps))))));
        };
        return _this;
    }
    ChartBase.prototype.getLabelList = function (props) {
        var labelListProps = props && props.labelList;
        if (labelListProps) {
            var labelFormatter = void 0;
            if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(labelListProps.dataKey)) {
                labelListProps.dataKey = props.dataKey;
            }
            if (!ksys_app_template_1.utils.typeChecks.isNullOrUndefined(labelListProps.formatter)) {
                labelFormatter = function (label) {
                    return formatter(labelListProps.formatter, label);
                };
            }
            var LabelListElement = Recharts['LabelList'];
            if (labelListProps.color) {
                return react_1.default.createElement(LabelListElement, __assign({}, labelListProps, { formatter: labelFormatter, fill: labelListProps.color }));
            }
            return react_1.default.createElement(LabelListElement, __assign({}, labelListProps, { formatter: labelFormatter }));
        }
    };
    ChartBase.prototype.getLabel = function (props) {
        var labelProps = props && props.label;
        if (labelProps) {
            var LabelElement = Recharts['Label'];
            return react_1.default.createElement(LabelElement, __assign({}, labelProps));
        }
    };
    ChartBase.prototype.getCells = function (props, data) {
        if (data === void 0) { data = []; }
        var colors = props && props.colors;
        if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(colors)) {
            var CellElement_1 = Recharts['Cell'];
            var cells_1 = [];
            if (typeof colors[0] === 'string') {
                // Color Strings
                var count = props && props.count;
                for (var idx = 0; idx < count; idx++) {
                    cells_1.push(react_1.default.createElement(CellElement_1, { key: "cell-" + idx, fill: colors[idx % colors.length] }));
                }
            }
            else {
                // Mapped Colors
                data.forEach(function (dataItem, idx) {
                    var color = colors.find(function (c) { return c.key === dataItem.name; });
                    cells_1.push(react_1.default.createElement(CellElement_1, { key: "cell-" + idx, fill: color && color.color }));
                });
            }
            return cells_1;
        }
    };
    ChartBase.prototype.getResponsiveContainerProps = function (props) {
        if (props) {
            var _a = props.responsiveContainerProps, responsiveContainerProps = _a === void 0 ? {} : _a, _b = props.composedChartProps, composedChartProps = _b === void 0 ? {} : _b, _c = props.elements, elements = _c === void 0 ? [] : _c;
            if (!responsiveContainerProps.forceHeight) {
                var barChartHeight = ChartBaseFunctions_1.calculateBarChartHeight(composedChartProps, elements);
                if (barChartHeight) {
                    responsiveContainerProps.height = barChartHeight;
                }
            }
            return responsiveContainerProps;
        }
        return {};
    };
    ChartBase.prototype.getChartContainerProps = function (id, summary, chartAccessibilitySummary) {
        if (summary) {
            return {
                role: 'img',
                'aria-labelledby': id,
            };
        }
        if (chartAccessibilitySummary && !summary) {
            return {
                role: 'img',
                'aria-label': chartAccessibilitySummary,
            };
        }
        return {
            'aria-hidden': true,
        };
    };
    ChartBase.prototype.render = function () {
        var _this = this;
        var className = this.props.className;
        var breakpoints = this.breakpoints;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
                return (react_1.default.createElement(Accessibility_1.AccessibilityContext.Consumer, null, function (accessibilityContext) {
                    return breakpoints.map(function (breakpoint, breakpointIndex) {
                        var props = breakpoint.props;
                        var breakpointProps = _this.getBreakpointComponentProps(breakpoint, breakpointIndex);
                        return (react_1.default.createElement(react_socks_1.default, __assign({}, breakpointProps),
                            react_1.default.createElement(Wrapper_1.default, { className: className }, _this.renderChart(props, translationContext, accessibilityContext))));
                    });
                }));
            })));
    };
    ChartBase = __decorate([
        mobx_react_1.observer
    ], ChartBase);
    return ChartBase;
}(shared_1.ResponsiveComponentBase));
exports.ChartBase = ChartBase;
exports.default = shared_1.InjectedStyledComponent(ChartBase, ChartBase_meta_1.CHART_BASE_CATEGORY_KEY, ChartBase_meta_1.CHART_BASE_COMPONENT_KEY);
